export const myRole = () => {
    const userRole = localStorage.getItem('role');
    const eventRoles = ['event'];
    const adminRoles = ['admin'];
    const financeRoles = ['finance'];
    const managementRoles = ['management'];
    if (eventRoles.includes(userRole)) {
        return 'event';
    } else if (adminRoles.includes(userRole)) {
        return 'admin';
    } else if (financeRoles.includes(userRole)) {
        return 'finance';
    } else if (managementRoles.includes(userRole)) {
       return 'management';
    }
};